import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ChartData, Plugin, Chart, ChartOptions, ChartEvent } from "chart.js";

const beforeDrawPlugin: Plugin = {
  id: "beforeDrawPlugin",
  beforeDraw(chart) {
    const ctx = chart.ctx;
    const width = chart.width;
    const height = chart.height;
    const text = ""; // Customize this text

    ctx.restore();
    ctx.font = "bold 20px Arial";
    ctx.textBaseline = "middle";

    const textX = Math.round((width - ctx.measureText(text).width) / 2);
    const textY = height / 2;

    ctx.fillText(text, textX, textY);
    ctx.save();
  }
};

Chart.register(beforeDrawPlugin);
@Component({
  selector: "app-bar-chart",
  templateUrl: "./bar-chart.component.html",
  styleUrls: ["./bar-chart.component.scss"]
})
export class BarChartComponent implements OnInit, OnChanges {
  @Input() isVertical!: boolean;
  @Input() labels: any;
  @Input() data: any;
  @Input() isRefreshChart!: boolean;

  public barChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      }
    },
    scales: {
      x: {
        beginAtZero: true // Ensures the x-axis starts from zero
      }
    }
  };

  public barChartData: ChartData<"bar"> = {
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
        backgroundColor: [],
        barPercentage: 0.5, // Adjust bar width
        categoryPercentage: 0.5
      }
    ]
  };

  baseColors: string[] = ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF", "#FF9F40"];

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isVertical) {
      this.barChartOptions.indexAxis = "y";
    }

    // Assuming `res.data.labels` contains labels and `res.data.values` contains data
    this.barChartData.labels = this.labels;
    this.barChartData.datasets[0].data = this.data;

    //
    if (this.data && this.data.length > 5) {
      this.barChartData.datasets[0].barPercentage = 0.5;
      this.barChartData.datasets[0].categoryPercentage = 0.5;
    } else {
      this.barChartData.datasets[0].barPercentage = 0.2;
      this.barChartData.datasets[0].categoryPercentage = 0.2;
    }

    // Generate colors based on the number of data points
    const colorCount = this.data?.length;
    this.barChartData.datasets[0].backgroundColor = this.generateColors(colorCount);

    // Trigger chart update by creating a new reference to `barChartData`
    this.barChartData = { ...this.barChartData };
  }

  ngOnInit(): void { }

  // Function to generate colors based on the count needed
  generateColors(count: number): string[] {
    const colors: string[] = [];
    for (let i = 0; i < count; i++) {
      const baseColor = this.baseColors[i % this.baseColors.length];
      const variation = i / count; // This creates a variation factor
      colors.push(this.adjustColorBrightness(baseColor, variation * 0.5)); // Adjust color brightness slightly
    }
    return colors;
  }

  // Function to adjust the brightness of a color
  adjustColorBrightness(color: string, amount: number): string {
    let col = color.substring(1); // Remove the #
    let num = parseInt(col, 16);
    let r = (num >> 16) + amount * 255;
    let g = ((num >> 8) & 0x00ff) + amount * 255;
    let b = (num & 0x0000ff) + amount * 255;

    return (
      "#" +
      (
        0x1000000 +
        (Math.min(255, Math.max(0, Math.round(r))) << 16) +
        (Math.min(255, Math.max(0, Math.round(g))) << 8) +
        Math.min(255, Math.max(0, Math.round(b)))
      )
        .toString(16)
        .slice(1)
    );
  }

  public chartClicked({ event, active }: { event: ChartEvent; active: object[] }): void {
    console.log(event, active);
  }

  public chartHovered({ event, active }: { event: ChartEvent; active: object[] }): void {
    console.log(event, active);
  }
}
